/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import actionCreatorFactory from 'typescript-fsa';
import { Album, AlbumSong, MusicbrainzRelease } from '../../../services/playlist';

const actionCreator = actionCreatorFactory();

export const ALBUM_LOAD = 'ALBUM_LOAD';
export const loadAlbum = actionCreator<string>(ALBUM_LOAD);

export const ALBUM_SET = 'ALBUM_SET';
export const setAlbum = actionCreator<Album>(ALBUM_SET);

export const ALBUM_SONGS_SET = 'ALBUM_SONGS_SET';
export const setAlbumSongs = actionCreator<AlbumSong[]>(ALBUM_SONGS_SET);

export const ALBUM_SAVE = 'ALBUM_SAVE';
export const saveAlbum = actionCreator<Album>(ALBUM_SAVE);

export const ALBUM_UPLOAD_IMAGE = 'ALBUM_UPLOAD_IMAGE';
export const uploadAlbumImage = actionCreator<File>(ALBUM_UPLOAD_IMAGE);

export const ALBUM_SET_UPLOADED_IMAGE_ID = 'ALBUM_SET_UPLOADED_IMAGE_ID';
export const setAlbumUploadedImageId = actionCreator<string>(ALBUM_SET_UPLOADED_IMAGE_ID);

export const ALBUM_SET_MUSICBRAINZ = 'ALBUM_SET_MUSICBRAINZ';
export const albumSetMusicbrainz = actionCreator<MusicbrainzRelease[]>(ALBUM_SET_MUSICBRAINZ);

export const ALBUM_LOAD_MUSICBRAINZ = 'ALBUM_LOAD_MUSICBRAINZ';
export const albumLoadMusicbrainz = actionCreator<string>(ALBUM_LOAD_MUSICBRAINZ);

export const ALBUM_LOAD_MUSICBRAINZ_DETAILS = 'ALBUM_LOAD_MUSICBRAINZ_DETAILS';
export const albumLoadMusicbrainzDetails = actionCreator<string>(ALBUM_LOAD_MUSICBRAINZ_DETAILS);

export const ALBUM_SET_MUSICBRAINZ_DETAILS = 'ALBUM_SET_MUSICBRAINZ_DETAILS';
export const albumSetMusicbrainzDetails = actionCreator<MusicbrainzRelease>(ALBUM_SET_MUSICBRAINZ_DETAILS);

export const ALBUM_SET_MUSICBRAINZ_LOADING = 'ALBUM_SET_MUSICBRAINZ_LOADING';
export const albumSetMusicbrainzLoading = actionCreator<boolean>(ALBUM_SET_MUSICBRAINZ_LOADING);

export const ALBUM_DELETE_COVER = 'ALBUM_DELETE_COVER';
export const albumDeleteCover = actionCreator<string>(ALBUM_DELETE_COVER);

export const ALBUM_DELETE = 'ALBUMALBUM_DELETE_DELETE_COVER';
export const albumDelete = actionCreator<string>(ALBUM_DELETE);

export const ALBUM_REMOVE_DUPLICATED_SONGS = 'ALBUM_REMOVE_DUPLICATED_SONGS';
export const albumRemoveDuplicatedSongs = actionCreator<string>(ALBUM_REMOVE_DUPLICATED_SONGS);

export const ALBUM_ATTACH_MUSICBRAINZ_COVER_ART = 'ALBUM_ATTACH_MUSICBRAINZ_COVER_ART';
export const albumAttachMusicbrainzCoverArt = actionCreator<{albumId: string, url: string}>(ALBUM_ATTACH_MUSICBRAINZ_COVER_ART);

export const ALBUM_ATTACH_COVER_ART_IMAGE = 'ALBUM_ATTACH_COVER_ART_IMAGE';
export const albumAttachCoverArtImage = actionCreator<{albumId: string, imageId: string}>(ALBUM_ATTACH_COVER_ART_IMAGE);

export const ALBUM_IMPORT_MUSICBRAINZ_RELEASE = 'ALBUM_IMPORT_MUSICBRAINZ_RELEASE';
export const albumImportMusicbrainzRelease = actionCreator<{albumId: string, releaseId: string}>(ALBUM_IMPORT_MUSICBRAINZ_RELEASE);
